import { SubscriptionService } from '../services/api/subscriptionService';
import type { AppNavFeatureCode } from '../components/AppShell/appNavFeatureCodes';

/**
 * Resolve nav feature codes with subscription precedence (model-map spec):
 * when company context is present, allow if user OR company grants the feature
 * via POST /subscriptions/check.
 */
export async function resolveNavFeatureAccess(
  userId: string,
  featureCodes: readonly AppNavFeatureCode[],
  companyId?: string | null
): Promise<Record<AppNavFeatureCode, boolean>> {
  const results = await Promise.all(
    featureCodes.map(async (code) => {
      const check = await SubscriptionService.checkFeature({
        feature_code: code,
        user_id: userId,
        ...(companyId ? { company_id: companyId } : {}),
      });
      return [code, Boolean(check.has_feature)] as const;
    })
  );

  return results.reduce(
    (acc, [code, allowed]) => {
      acc[code] = allowed;
      return acc;
    },
    {} as Record<AppNavFeatureCode, boolean>
  );
}
